import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-manual-collections-confirmation',
  templateUrl: './delete-manual-collections-confirmation.component.html',
  styleUrls: ['./delete-manual-collections-confirmation.component.css']
})
export class DeleteManualCollectionsConfirmationComponent {

  constructor(public dialogRef: MatDialogRef<any>) {}

  submit() {
      this.dialogRef.close(true);
  }

}
